var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3483_31317",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3483_31317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 10.4H7.19998V5.59998H5.99998V10.4ZM8.79998 10.4H9.99998V5.59998H8.79998V10.4ZM7.99998 14.4C7.12211 14.4 6.29438 14.2333 5.51678 13.9C4.73918 13.5666 4.05864 13.1082 3.47518 12.5248C2.89171 11.9413 2.43331 11.2608 2.09998 10.4832C1.76664 9.70558 1.59998 8.87784 1.59998 7.99998C1.59998 7.11091 1.76664 6.28024 2.09998 5.50798C2.43331 4.73624 2.89171 4.05864 3.47518 3.47518C4.05864 2.89171 4.73918 2.43331 5.51678 2.09998C6.29438 1.76664 7.12211 1.59998 7.99998 1.59998C8.88904 1.59998 9.71971 1.76664 10.492 2.09998C11.2637 2.43331 11.9413 2.89171 12.5248 3.47518C13.1082 4.05864 13.5666 4.73624 13.9 5.50798C14.2333 6.28024 14.4 7.11091 14.4 7.99998C14.4 8.87784 14.2333 9.70558 13.9 10.4832C13.5666 11.2608 13.1082 11.9413 12.5248 12.5248C11.9413 13.1082 11.2637 13.5666 10.492 13.9C9.71971 14.2333 8.88904 14.4 7.99998 14.4ZM7.99998 13.2C9.44424 13.2 10.672 12.6944 11.6832 11.6832C12.6944 10.672 13.2 9.44424 13.2 7.99998C13.2 6.55571 12.6944 5.32798 11.6832 4.31678C10.672 3.30558 9.44424 2.79998 7.99998 2.79998C6.55571 2.79998 5.32798 3.30558 4.31678 4.31678C3.30558 5.32798 2.79998 6.55571 2.79998 7.99998C2.79998 9.44424 3.30558 10.672 4.31678 11.6832C5.32798 12.6944 6.55571 13.2 7.99998 13.2Z",
    fill: "#FF8533"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.36b95741281f8ad58eea3ee133b2eab8.svg";
export { ForwardRef as ReactComponent };